import { useEffect } from 'react';

const SaveStateSync = ({
    dirty,
    errors,
    permissionsSet,
    oldPermissionsSet,
    permissionsSubmitData,
    setIsSaveDisabled,
}) => {
    useEffect(() => {
        const hasPermissionChanges =
            Object.keys(permissionsSubmitData || {}).length > 0;
        const hasFieldChanges =
            dirty ||
            permissionsSet?.companyID !== oldPermissionsSet?.companyID ||
            permissionsSet?.readOnly !== oldPermissionsSet?.readOnly ||
            permissionsSet?.optOutOfNew !== oldPermissionsSet?.optOutOfNew;
        const hasErrors = Object.keys(errors || {}).length > 0;

        setIsSaveDisabled(
            hasErrors || !(hasPermissionChanges || hasFieldChanges),
        );
    }, [
        dirty,
        errors,
        permissionsSet,
        oldPermissionsSet,
        permissionsSubmitData,
        setIsSaveDisabled,
    ]);

    return null;
};

export default SaveStateSync;
